import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { MutationCompleteOutboundLeadTaskArgs } from '@api/generated/graphql';
import extractErrorMessage from '@lib/utils/extractErrorMessage';

export const COMPLETE_OUTBOUND_LEAD_TASK_MUTATION = graphql(`
  mutation CompleteOutboundLeadTask(
    $taskId: ID!
    $tenantId: ID!
    $input: TaskCompleteInput!
  ) {
    completeOutboundLeadTask(
      taskId: $taskId
      tenantId: $tenantId
      input: $input
    )
  }
`);

export const completeTask = async (
  variables: MutationCompleteOutboundLeadTaskArgs,
): Promise<boolean> => {
  try {
    const { data } = await getClient().mutate({
      mutation: COMPLETE_OUTBOUND_LEAD_TASK_MUTATION,
      variables,
    });

    if (!data?.completeOutboundLeadTask) {
      throw new Error('Failed to complete speed to lead task');
    }

    return data.completeOutboundLeadTask;
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};
